import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Reveal } from "@/components/Section";
import { useContent } from "@/i18n";
import { Shape3D } from "@/components/Objects3D";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function JournalPost() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [notFound, setNotFound] = useState(false);
  const { ui, lang } = useContent();
  const pick = (p, field) => (lang === "de" && p[`${field}_de`] ? p[`${field}_de`] : p[field]);

  useEffect(() => {
    window.scrollTo(0, 0);
    fetch(`${API}/journal/${slug}`)
      .then((r) => {
        if (!r.ok) throw new Error("not found");
        return r.json();
      })
      .then(setPost)
      .catch(() => setNotFound(true));
  }, [slug]);

  return (
    <main className="min-h-screen bg-cream relative overflow-hidden" data-testid="journal-post-page">
      <Shape3D shape="book" blue size={48} className="absolute right-[10%] top-24 opacity-80 hidden md:block" />
      <div className="max-w-3xl mx-auto px-6 pt-10 pb-28 relative">
        <Link
          to="/journal"
          data-testid="post-back-link"
          className="group inline-flex items-center gap-3 text-xs tracking-[0.2em] uppercase font-bold text-cocoa hover:text-choco transition-colors duration-300"
        >
          <ArrowLeft size={14} className="transition-transform duration-300 group-hover:-translate-x-1" />
          {ui.journal.allEssays}
        </Link>

        {notFound && (
          <p className="mt-20 font-serif italic text-3xl text-cocoa" data-testid="post-not-found">
            {ui.journal.notFound}
          </p>
        )}

        {post && (
          <article>
            <Reveal>
              <p className="mt-14 text-[10px] tracking-[0.28em] uppercase font-bold text-cobalt">
                {pick(post, "tag")} · {post.date} · {pick(post, "read_time")}
              </p>
              <h1 className="mt-6 font-serif text-4xl md:text-6xl tracking-tighter leading-[1.02]" data-testid="post-title">
                {pick(post, "title")}
              </h1>
            </Reveal>
            <Reveal delay={0.15}>
              <div className="mt-10 overflow-hidden rounded-2xl aspect-[16/9] shadow-[0_26px_60px_-34px_rgba(51,38,25,0.35)]">
                <img src={post.image} alt={pick(post, "title")} className="w-full h-full object-cover" />
              </div>
            </Reveal>
            <div className="mt-12 space-y-7">
              {(pick(post, "content") || []).map((para, i) => (
                <Reveal key={i} delay={0.03 * i}>
                  <p className={`leading-relaxed ${i === 0 ? "font-serif text-xl md:text-2xl text-choco" : "text-base md:text-lg text-cocoa"}`}>
                    {para}
                  </p>
                </Reveal>
              ))}
            </div>
            <Reveal delay={0.1}>
              <p className="mt-14 pt-8 border-t border-line font-serif italic text-xl text-cobalt">— Sahithi</p>
            </Reveal>
          </article>
        )}
      </div>
    </main>
  );
}
